<template>
  <div id="app" :class="`${overflow ? 'app-overflow' : ''}`">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  computed: {
    overflow() {
      if (this.$route.name === 'Home' ||
        this.$route.name === 'Infographics' ||
        this.$route.name === 'Infographics Scene'
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "~normalize.css";

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
  -ms-overflow-style: none;
  background-color: #fffafa;
  // overflow: hidden;

  @media screen and (max-width: 768px) {
    overflow: visible;
  }
}

.container,
.dashboard {
  position: relative;
  height: 100%;
}

.dashboard {
  padding: 15px;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}

.app-overflow {
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    overflow-x: auto;
  }

  @media screen and (max-width: 1024px) and (max-height: 575px) {
    overflow-y: auto;
  }
}
</style>
